class CartNotification extends HTMLElement {
	constructor() {
		super();
		const appHeight = () => {
			const doc = document.documentElement;
			doc.style.setProperty('--viewport-height', `${window.innerHeight}px`);
		};
		window.addEventListener('resize', appHeight);
		appHeight();

		this.notification = document.getElementById('cart-notification');
		this.header = document.querySelector('sticky-header');
		this.onBodyClick = this.handleBodyClick.bind(this);

		this.notification.addEventListener(
			'keyup',
			(evt) => evt.code === 'Escape' && this.close()
		);
		this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
			closeButton.addEventListener('click', this.close.bind(this));
		});
	}

	open() {
		var self = this;
		this.notification.classList.add('animate', 'active');
		document.body.classList.add('show-mini');
		$(".cart-notification-wrapper .cart-notification-product").scrollTop(0);
		this.notification.addEventListener(
			'transitionend',
			() => {
				this.notification.focus();
				trapFocus(this.notification);
			},
			{ once: true }
		);
		// align height
		function alignHeight(selector) {
			jQuery(selector).css('height', '');
			var minHeight = 0;
			jQuery(selector).each(function () {
				if (minHeight < jQuery(this).outerHeight()) {
					minHeight = jQuery(this).outerHeight();
				}
			});
			if (minHeight > 0) {
				jQuery(selector).css('height', minHeight);
			}
		}
		function alignHeightRow(selector, n) {
			var items = jQuery(selector);
			var newArrays = new Array(Math.ceil(items.length / n))
				.fill()
				.map((_) => items.splice(0, n));

			$(newArrays).each(function () {
				jQuery(this).css('height', '');
				var minHeight = 0;
				jQuery(this).each(function () {
					if (minHeight < jQuery(this).outerHeight()) {
						minHeight = jQuery(this).outerHeight();
					}
				});
				if (minHeight > 0) {
					jQuery(this).css('height', minHeight);
				}
			});
		}
		setTimeout(function () {
			alignHeightRow('.sub-collections a p', 2);
			alignHeightRow('.product-grid .card-wrapper .card__heading', 2);
			alignHeightRow('.card-wrapper .price__container', 2);
			alignHeightRow('.shipping-time-and-cart', 2);
		}, 500);
		jQuery(window).resize(function () {
			setTimeout(function () {
				alignHeightRow('.sub-collections a p', 2);
				alignHeightRow('.product-grid .card-wrapper .card__heading', 2);
				alignHeightRow('.card-wrapper .price__container', 2);
				alignHeightRow('.shipping-time-and-cart', 2);
			}, 500);
		});

		document.body.addEventListener('click', this.onBodyClick);
		$(document)
			.find('.cart-notification__header-desktop')
			.on('click', function () {
				self.close();
			});
		$(document).on('click', function (e) {
			var container = $('.cart-notification');
			if (!$(e.target).closest(container).length) {
				self.close();
			}
		});
	}

	close() {
		this.notification.classList.remove('active');
		document.body.classList.remove('show-mini');
		document.body.removeEventListener('click', this.onBodyClick);

		// removeTrapFocus(this.activeElement);
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.getSectionsToRender().forEach((section) => {
			document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		if (this.header) this.header.reveal();
		this.open();
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-notification-product',
				selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
			},
			{
				id: 'cart-notification-button',
			},
			{
				id: 'cart-icon-bubble',
			},
		];
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	handleBodyClick(evt) {
		const target = evt.target;
		if (target !== this.notification && !target.closest('cart-notification')) {
			const disclosure = target.closest('details-disclosure');
			this.activeElement = disclosure
				? disclosure.querySelector('summary')
				: null;
			this.close();
		}
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-notification', CartNotification);
